import React from 'react';
import { shape, string, number, arrayOf } from 'prop-types';
import classNames from 'classnames';
import CreditOffer from '../credit-offer/credit-offer';

const namespace = 'ui-pdp-mc-benefits';

const CreditsOfferBenefits = ({ creditOffer }) =>
  creditOffer && (
    <div className={classNames(namespace)}>
      <CreditOffer {...creditOffer} />
    </div>
  );

CreditsOfferBenefits.propTypes = {
  creditOffer: shape({
    image: shape({
      alt: string.isRequired,
      url: shape({
        src: string.isRequired,
      }),
      width: number.isRequired,
      height: number.isRequired,
    }).isRequired,
    title: shape({
      text: string.isRequired,
      color: string,
      font_size: string,
      font_family: string,
    }).isRequired,
    subtitles: arrayOf(
      shape({
        text: string.isRequired,
        color: string,
        font_size: string,
        font_family: string,
      }),
    ),
  }).isRequired,
};

export default CreditsOfferBenefits;
